import transactionDetails from "./transactionDetails"
export default transactionDetails;
